import { render } from "./FaceStartButton.vue?vue&type=template&id=35287531&scoped=true"
import script from "./FaceStartButton.vue?vue&type=script&lang=js"
export * from "./FaceStartButton.vue?vue&type=script&lang=js"

import "./FaceStartButton.vue?vue&type=style&index=0&id=35287531&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-35287531"

export default script